import { render, staticRenderFns } from "./Pager.vue?vue&type=template&id=0a7c73a0"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"
import style0 from "./Pager.vue?vue&type=style&index=0&id=0a7c73a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports